import { createAction, props } from '@ngrx/store';

export interface SupportState {
  chatOpen: boolean;
  chatIconOpen: boolean;
  unreadSupportMessagesCount: number;
  visualGuidesOpen: boolean;
  visualGuidesCount: number;
}

export const ToggleSupportChat = createAction(
  '[Support] ToggleChat',
  props<{ force?: boolean }>()
);
export const ToggleSupportChatIcon = createAction(
  '[Support] ToggleChatIcon',
  props<{ force?: boolean }>()
);
export const ToggleVisualGuidesIcon = createAction(
  '[Support] ToggleGuidesIcon',
  props<{ force?: boolean }>()
);

export const restoreSupportIconState = createAction(
  '[Support] RestoreState',
  props<SupportState>()
);
export const setUnreadMessagesCount = createAction(
  '[Support] UnreadMessagesCount',
  props<{ count: number }>()
);
export const setVisualGuidesCount = createAction(
  '[Support] VisualGuidesCount',
  props<{ count: number }>()
);
